// extracted by mini-css-extract-plugin
module.exports = {"Grid":"Grid--2tz2Z"};